import createSagaMiddleware, {channel} from "redux-saga";
import {applyMiddleware, compose, createStore} from "redux";
import {Map} from "immutable";
import reducer from "./store/reducer";
import actionFactories from "./store/actions";
import undoStoreEnhancer from "./store/undo";
import storage from "./utils/storage";

const init = ({initialState = null, host=null}) => {
    const sagaMiddleware = createSagaMiddleware();
    if (initialState) {
        for (const [key, value] of Object.entries(initialState)) {
            if (typeof value === 'object' && value.$type === 'Map') {
                initialState[key] = Map().withMutations((map) => {
                    value.entries.forEach(([key,val]) => map.set(key, val));
                });
            }
        }
        initialState.time = new Date(initialState.time);
    }
    const store = createStore(
        reducer,
        initialState || {},
        compose(
            applyMiddleware(sagaMiddleware),
            undoStoreEnhancer(),
        )
    );
    const actions = {};
    for (const [key, make] of Object.entries(actionFactories)) {
        actions[key] = (...args) => store.dispatch({type: key, payload: make(...args)});
    }

    // This channel is used to indicate that API calls can proceed.
    const readyCh = channel();

    if (!initialState) {
        actions.init(host);
        try {
            const settings = JSON.parse(storage.getItem('settings') || 'null');
            actions.settingsLoaded(settings);
        } catch {
            // Clear bad settings.
            storage.removeItem('settings');
            actions.settingsLoaded({});
        }
        try {
            const communities = JSON.parse(storage.getItem('communities') || 'null');
            actions.communityListLoaded('communities', communities || [], Date.now() + 2 * 60 * 1000);
        } catch {
            // Clear bad communities.
            storage.removeItem('communities');
            actions.communityListLoaded('communities', [], 0);
        }
    }

    return { store, actions, sagaMiddleware, readyCh };
};

export default init;
